import React, { FC, useMemo } from 'react';
import { connect } from 'react-redux';

import { RootState } from 'redux/reducers';
import { useActivityScoreAPI } from 'services/course-api';

import AssignmentScores from './AssignmentScores';
import DiscussionScores from './DiscussionScores';
import PollScores from './PollScores';
import QuizScores from './QuizScores';

interface ActivityScoresProps {
  accessData: SessionData | null;
}

const ActivityScores: FC<ActivityScoresProps> = () => {
  const { data: scores, isLoading } = useActivityScoreAPI();

  const hasScoreData = useMemo(() => {
    if (!scores) return false;
    return !!(
      scores.quiz.length ||
      scores.poll.length ||
      scores.discussion.length ||
      scores.class.length ||
      scores.assignment.length
    );
  }, [scores]);

  return (
    <article className='section'>
      <div className='section__header'>
        {isLoading ? (
          <h3 className='section__title'>Loading scores...</h3>
        ) : (
          <h3 className='section__title'>
            {!hasScoreData ? 'No data available to export' : 'Scores Available for Export'}
          </h3>
        )}
      </div>
      {!isLoading && (
        <div className='section__body'>
          <QuizScores data={scores?.quiz} />
          <PollScores data={scores?.poll} />
          <DiscussionScores data={scores?.discussion} />
          <AssignmentScores data={scores?.assignment} />
        </div>
      )}
    </article>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    accessData: state.getAccess,
  };
};

export default connect(mapStateToProps)(ActivityScores);
